import React from 'react';
import { Group, Rect } from 'react-konva';
import { useEditorStore } from '../../store/editorStore';
import { useShallow } from 'zustand/react/shallow';

export const OverlayLayer: React.FC = () => {
  const { marquee, stageScale } = useEditorStore(useShallow(state => ({
    marquee: state.marquee, stageScale: state.stageScale
  })));

  return (
    <Group listening={false}>
      {/* Marquee selection rectangle */}
      {marquee && (
        <Rect
          x={marquee.x}
          y={marquee.y}
          width={marquee.w}
          height={marquee.h}
          fill="rgba(59, 130, 246, 0.2)"
          stroke="#3b82f6"
          strokeWidth={1 / stageScale}
        />
      )}
    </Group>
  );
};
